import "./OurStory.module.css";
import Header from "@/reusable_sections/Header";
import EastTexasRoots from "./sections/EastTexasRoots";
import WhyTheSharkBite from "./sections/WhyTheSharkBite";
import Footer from "@/reusable_sections/Footer";
export default function OurStoryPage() {
  return <div>
      <Header />
      <EastTexasRoots />
      <WhyTheSharkBite />
      <Footer />
    </div>;
}